import { Alert, Box } from "@mui/material";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function Home() {
    useEffect(() => {
        document.location = "https://2221.ch"
    })
    return null
}